import type * as GraphQLTypes from '../../../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveGiftCardFromPackageMutationVariables = GraphQLTypes.Exact<{
  code: GraphQLTypes.Scalars['String'];
  id: GraphQLTypes.Scalars['String'];
}>;


export type RemoveGiftCardFromPackageMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'removeGiftCardFromPackage'>
);


export const RemoveGiftCardFromPackageDocument = /*#__PURE__*/ gql`
    mutation removeGiftCardFromPackage($code: String!, $id: String!) {
  removeGiftCardFromPackage(code: $code, id: $id)
}
    `;

/**
 * __useRemoveGiftCardFromPackageMutation__
 *
 * To run a mutation, you first call `useRemoveGiftCardFromPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGiftCardFromPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGiftCardFromPackageMutation, { data, loading, error }] = useRemoveGiftCardFromPackageMutation({
 *   variables: {
 *      code: // value for 'code'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGiftCardFromPackageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGiftCardFromPackageMutationResult, RemoveGiftCardFromPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGiftCardFromPackageMutationResult, RemoveGiftCardFromPackageMutationVariables>(RemoveGiftCardFromPackageDocument, options);
      }
export type RemoveGiftCardFromPackageMutationHookResult = ReturnType<typeof useRemoveGiftCardFromPackageMutation>;